import * as React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Card from "../components/card"
import Button from "../components/button"

import bg1 from "../images/DT_intro_background.png";
import bg2 from "../images/docent_office-1.jpg";
import bg3 from "../images/placeholder_bg2.jpg";

export default function IndexPage({ data }) {
  {/* 
  const {
    news1,
    news2,
    news3
  } = data.allContentfulNews.edges.node
  */}

  return(
    <Layout>
      <SEO title="Home" />
      <div className="grid grid-flow-rows grid-rows-min gap-4">
        <section className="p-8 flex flex-wrap flex-col md:flex-row justify-between">
          <div className="md:w-7/12">
            <h1 className="font-dokdo text-2xl text-gray-600">What's new?</h1>
            {/*black news box*/}
            <section className="bg-black h-5/6 shadow rounded-xl text-offwhite">
              <div className="flex flex-col md:flex-row justify-center md:justify-between items-center px-6 py-4 h-4/5">
                <div className="order-2 md:order-none md:w-2/5 text-center">
                  <h1 className="font-dokdo text-6xl leading-none md:-mr-8">{data.allContentfulNews.title}</h1>
                  <p className="font-overpass-light text-sm h-full md:-mr-8 overflow-truncate overflow-hidden">{data.allContentfulNews.body}</p>
                </div>
                <iframe 
                  src="https://www.youtube.com/embed/xFINRxxclyM" 
                  className="order-1 md:order-none w-full md:w-auto h-auto"
                />
              </div>
              <div className="grid grid-cols-3 h-1/5 rounded-b-xl font-dokdo text-2xl text-center items-center py-4 border-t-2 divide-x">
                <span className="">test test</span>
                <span>test test</span>
                <span>test test</span>
              </div>
            </section>
          </div>
          <div className="flex flex-col items-center md:w-5/12">
            <StaticImage 
              src="../images/DT_portrait.png"
              className="relative w-1/3"
            />
            <p className="bg-purple-200 bg-opacity-75 rounded-xl w-2/3 p-8 pt-10 pb-5 -mt-8 font-overpass text-sm">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
          </div>
        </section>
        <section className="flex flex-wrap bg-cover bg-fixed p-8 gap-4 items-center justify-around md:justify-between" style={{backgroundImage: "url(" + bg1 + ")"}}>
          <Card
            ph={<StaticImage src="../images/test-thumb.jpg"/>}
            title="test title" 
            description="this is how the world ends"
          />
          <Button link="https://www.youtube.com/channel/UCC3FPNHNFOg7WGqoq-m08nw">more videos</Button>
        </section>
        <section className="flex flex-wrap-reverse bg-cover bg-fixed p-8 gap-4 items-center justify-around md:justify-between" style={{backgroundImage: "url(" + bg2 + ")"}}>
          <Button/>
          <Card
            ph={<StaticImage src="../images/test-thumb.jpg"/>}
            title="test title" 
            description="this is how the world ends"
          />
        </section>
        <section className="flex flex-wrap bg-cover bg-fixed p-8 gap-4 items-center justify-around md:justify-between" style={{backgroundImage: "url(" + bg3 + ")"}}>
          <Card
            ph={<iframe src="https://www.youtube.com/embed/xFINRxxclyM"/>}
            title="test title" 
            description="this is how the world ends"
          />
          <Button/>
        </section>
        
      </div>
    </Layout>
  )
}
export const query = graphql`
query HomePageQuery {
  allContentfulNews (sort: {order: DESC, fields: datePosted}, limit: 3) {
    edges {
			node {
				title
        datePosted
        body {
					body
        }
      }
    }
  }
}
`